import { render, staticRenderFns } from "./FormOccurrence.vue?vue&type=template&id=28bf25d0&scoped=true"
import script from "./FormOccurrence.vue?vue&type=script&lang=js"
export * from "./FormOccurrence.vue?vue&type=script&lang=js"
import style0 from "./FormOccurrence.vue?vue&type=style&index=0&id=28bf25d0&prod&lang=scss&scoped=true"
import style1 from "./FormOccurrence.vue?vue&type=style&index=1&id=28bf25d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf25d0",
  null
  
)

export default component.exports